const UUID_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
export function createUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return UUID_TEMPLATE.replaceAll(/[xy]/g, (char) => {
    const random = Math.trunc(Math.random() * 16);
    const digit = char === 'x' ? random : (random % 4) + 8;

    return digit.toString(16);
  });
}
